import { VaultMark, SOCIAL_ICONS } from "@/components/Glyphs";
import { SITE, SOCIALS } from "@/data/site";
import { LEGAL_LINKS } from "@/data/legal";

const PRODUCT = [
  { label: "Features", href: "/#features" },
  { label: "Pricing", href: "/pricing" },
  { label: "About", href: "/about" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" },
];

const ACCOUNT = [
  { label: "Delete My Account", href: "/delete-account.html" },
  { label: "Delete My Data", href: "/delete-data.html" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative mt-24 border-t border-border bg-card/40">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="/" className="flex items-center gap-2.5 text-foreground">
              <span className="text-gold"><VaultMark className="h-7 w-7" /></span>
              <span className="font-display text-lg font-extrabold tracking-tight">Warranty_Vault pro</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              Store, track, and manage all your receipts, warranties and product documents in one secure place.
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.icon];
                return (
                  <a
                    key={s.href}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    data-testid={`footer-social-${s.icon}`}
                    className="grid h-10 w-10 place-items-center rounded-full border border-border bg-background text-foreground/80 transition-colors hover:border-gold/50 hover:text-gold"
                  >
                    <Icon className="h-[18px] w-[18px]" />
                  </a>
                );
              })}
            </div>
          </div>

          <FooterCol title="Product" links={PRODUCT} />
          <FooterCol title="Legal" links={LEGAL_LINKS} />
          <FooterCol title="Account & Data" links={ACCOUNT} danger />
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row">
          <p data-testid="footer-copyright">{SITE.copyright}</p>
          <a href={`mailto:${SITE.supportEmail}`} className="transition-colors hover:text-gold">
            {SITE.supportEmail}
          </a>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links, danger }) => (
  <div>
    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-foreground">{title}</h4>
    <ul className="mt-4 space-y-2.5">
      {links.map((l) => (
        <li key={l.href}>
          <a
            href={l.href}
            className={`text-sm transition-colors ${danger ? "text-muted-foreground hover:text-destructive" : "text-muted-foreground hover:text-gold"}`}
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
